import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { getCountries, getLocations } from '../../../../../../redux/actions/countries'
import { getLanguages } from '../../../../../../redux/actions/languages'
import { getRoles } from '../../../../../../redux/actions/roles'
import { showProfileUser } from '../../../../../../redux/actions/users'
import { IRootState } from '../../../../../../redux/types'

export function useInitialState() {
  const dispatch = useDispatch()
  const { id } = useParams<{ id: string }>()

  const { userProfileSelected } = useSelector((state: IRootState) => state.user)
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { roles } = useSelector((state: IRootState) => state.role)
  const { countries } = useSelector((state: IRootState) => state.country)
  const { languages } = useSelector((state: IRootState) => state.language)

  const [userId, setUserId] = useState<number | null>(null)

  useEffect(() => {
    if (roles.length === 0) dispatch(getRoles())
    if (countries.length === 0) dispatch(getCountries())
    if (languages.length === 0) dispatch(getLanguages())

    dispatch(getLocations())
  }, [])

  useEffect(() => {
    if (authUser !== null) {
      let userId: number
      if (id !== null && id !== undefined) userId = Number(id)
      else userId = authUser.id

      setUserId(userId)

      if (userProfileSelected?.id !== userId) dispatch(showProfileUser(userId))
    }
  }, [authUser])

  return userId
}
